import { Component, Input, OnChanges } from "@angular/core";
import {
  FirstTimePickupStepValues,
  LocalDeliveryStepValues,
  LocalPickupStepValues,
  OrderStepForAnyServiceType,
  orderStepToString,
} from "src/services/order/order.interface";

@Component({
  selector: "rc-order-step-badge",
  templateUrl: "./order-step-badge.component.html",
  styleUrls: ["./order-step-badge.component.scss"],
  standalone: false,
})
export class OrderStepBadgeComponent implements OnChanges {
  @Input() public orderNextStep: OrderStepForAnyServiceType;

  public color: string;

  constructor() {}

  public ngOnChanges() {
    switch (this.orderNextStep) {
      case FirstTimePickupStepValues.reviewOrder:
      case LocalDeliveryStepValues.reviewOrder:
      case LocalPickupStepValues.reviewOrder:
        this.color = "grey";
        break;

      case FirstTimePickupStepValues.assignDriver:
      case FirstTimePickupStepValues.acceptOrRejectOrder:
      case FirstTimePickupStepValues.schedulePickup:
      case FirstTimePickupStepValues.startPickup:
      case FirstTimePickupStepValues.completePickup:
      case FirstTimePickupStepValues.dropGearToWarehouseManager:
      case FirstTimePickupStepValues.onboardGear:
      case LocalDeliveryStepValues.putItemInStagingZone:
      case LocalDeliveryStepValues.assignDriver:
      case LocalDeliveryStepValues.acceptOrRejectOrder:
      case LocalDeliveryStepValues.startPickupInWarehouse:
      case LocalDeliveryStepValues.completePickupInWarehouse:
      case LocalDeliveryStepValues.startDelivery:
      case LocalPickupStepValues.assignDriver:
      case LocalPickupStepValues.acceptOrRejectOrder:
      case LocalPickupStepValues.schedulePickup:
      case LocalPickupStepValues.startPickup:
      case LocalPickupStepValues.completePickup:
      case LocalPickupStepValues.dropGearToWarehouseManager:
      case LocalPickupStepValues.storeGear:
        this.color = "gold";
        break;

      case FirstTimePickupStepValues.completeOnBoarding:
      case LocalDeliveryStepValues.completeDelivery:
        this.color = "moss";
        break;

      case LocalPickupStepValues.completed:
        this.color = "success";
        break;

      default:
        this.color = "warning";
    }
  }

  public readonly orderStepToString = orderStepToString;
}
